/*
 * Fernhollow Square — canonical palette.
 *
 * Source of truth: setup/CLAUDE.md → "Aesthetic guardrails" → "Palette (do not drift)".
 *
 * Mirrored as CSS variables in src/ui/ui.css so HTML overlays match the canvas.
 * If you change a hex here, change ui.css too — and ideally update the AESTHETIC doc.
 *
 * Pixi colors are numbers (0xRRGGBB), not CSS strings. We expose both forms so call
 * sites can stay readable: PALETTE.mossDeep for Pixi, PALETTE_HEX.mossDeep for CSS.
 */

export const PALETTE_HEX = {
  mossDeep: '#2d4a3a',
  mossMid: '#3e6e4f',
  mossLight: '#6ba07a',
  cream: '#f4ecd8',
  twilight: '#4a3b6b',
  twilightMid: '#5a5b7a',
  twilightDeep: '#2d1f47',
  mushroomRed: '#c9514c',
  lantern: '#ffc56b',
  water: '#4a7090',
  umberDeep: '#7a4a2e',
} as const;

export type PaletteHexKey = keyof typeof PALETTE_HEX;

/** Convert "#rrggbb" → 0xrrggbb for PixiJS tint / fill APIs. */
export function hexToNum(hex: string): number {
  return parseInt(hex.replace('#', ''), 16);
}

export const PALETTE = Object.fromEntries(
  Object.entries(PALETTE_HEX).map(([k, v]) => [k, hexToNum(v)])
) as { [K in PaletteHexKey]: number };

// World-space dimensions. The game is authored at 600×800 and scaled to fit
// the container; preserving these constants keeps drawing math identical to v0.2.
export const WORLD = {
  width: 600,
  height: 800,
  wellX: 300,
  wellY: 460,
} as const;
